import _ from 'lodash'
import { JSONEditor } from '@json-editor/json-editor'

const SelectEditor = JSONEditor.defaults.editors.select

class DatasetEditor extends SelectEditor {
  preBuild () {
    this.schema.enum = _.map(this.jsoneditor.options.datasets, 'name')
    super.preBuild()
  }
}

export default DatasetEditor
